import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

/** CSS 与组件动画使用同一个系统偏好，不写入浏览器或服务端配置。 */
export function useReducedMotion(): boolean {
  const [reducedMotion, setReducedMotion] = useState(() => globalThis.matchMedia?.(QUERY).matches ?? false);

  useEffect(() => {
    const media = globalThis.matchMedia?.(QUERY);
    if (!media) return;
    const update = () => setReducedMotion(media.matches);
    update();
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  return reducedMotion;
}
